import TitleUpdater from "../../components/shared/title/TitleUpdater";
import ContactSection from "../../components/pages/home/contact-section/ContactSection";
import MobileAppSection from "../../components/pages/home/mobile-app-section/MobileAppSection";
import styles from "./Contact.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
const Contact = () => {
  const { data } = useSelector((state: RootState) => state.translationData);
  return (
    <div id={styles.contact_page}>
      <TitleUpdater
        title={
          data?.colibri && data?.contact
            ? `${data?.colibri} | ${data?.contact}`
            : "Colibri"
        }
      />
      <ContactSection />
      <MobileAppSection />
    </div>
  );
};

export default Contact;
